export default __webpack_public_path__ + "static/media/T12.fc853016.png";